import { useCallback, useEffect, useState } from 'react';
import { openAppInit } from '@utils/tools';

/**
 * deepLink  站外 打开孕育app或下载app
 * @param url 打开app指定页的地址
 */
export default url => {
  const [wla, setWla] = useState();

  const getWla = useCallback(async () => {
    const wlaObj = await openAppInit({
      url: url || window.location.href
    });
    setWla(wlaObj);
  }, []);

  useEffect(() => {
    getWla().catch(error=>console.error(error));
    return () => {
      wla && wla.destroy();
    };
  }, []);

  return [wla];
};
